import React from 'react';
export var DataLayer = function DataLayer(_ref) {
  var customScript = _ref.customScript,
    pageEventData = _ref.pageEventData;
  var getScriptContent = function getScriptContent() {
    if (pageEventData) {
      return "var pageObject = ".concat(pageEventData, ";\n      if (pageObject) {\n        ").concat(customScript, "\n        window.dataLayer.push(pageObject);\n      }");
    }
    return '';
  };
  var scriptContent = "(function () {\n    window.dataLayer = window.dataLayer || [];\n    ".concat(getScriptContent(), "\n  })();");
  return /*#__PURE__*/React.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: scriptContent
    }
  });
};